import React, { useMemo } from 'react'
import IconTextView from "../icon-text-view"
import { HourglassEmptyIcon } from "../../../../ui/icon"

const loadingMessages = [
    "Waking up the lazy server...",
    "Hang in there, I will be right with you...",
    "Picking up the tiles that fell on the ground...",
    "Inserting the game CD into the server...",
    "Finishing painting a few tiles...",
    "Finishing proofreading the game rules...",
]

function getRandomLoadingMessage() {
    return loadingMessages[Math.floor(Math.random() * loadingMessages.length)]
}

export default function LoadingView() {
    const text = useMemo(getRandomLoadingMessage, [])
    
    return (
        <IconTextView
            icon={<HourglassEmptyIcon />}
            text={text}
        />
    )
}